import styled from 'styled-components';
import { ButtonProps } from './button';

export const ButtonContent = styled.div`
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 0;
  white-space: nowrap;
  padding: 10px;
  img {
    object-fit: cover;
  }
  @media (max-width: 768px) {
    padding: ${({ $forIcon }) => $forIcon && '0 8px'};
  }
`;

export const StyledButton = styled.button`
  position: relative;
  overflow: auto;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  flex: 1 0 0;
  border-radius: 8px;
  border: none;
  cursor: pointer;

  ${({ $variant }) => buttonVariants[$variant] || buttonVariants.gray};
  ${({ $fill }) => $fill && 'width: 100%;'};
`;

const buttonVariants: Record<ButtonProps['variant'], ReturnType<typeof css>> = {
  primary: `
    color: #edeff5;
    border-radius: 8px;
    background: #3d383f;
    overflow: hidden;

    &:hover {
      opacity: 0.9;
    }

    &:active {
      opacity: 0.9;
      background: #3d383f;
    }
      &:disabled {
    cursor:not-allowed;
    opacity: 0.4;
    }
  `,

  orangeGradient: `
    color: #edeff5;
    border-radius: 8px;
    background: linear-gradient(90deg, #FF9500 0%, #FF5E00 100%);
    overflow: visible;

    &:hover {
      opacity: 0.9;
    }

    &:active {
      opacity: 0.9;
    }

    &:disabled {
    cursor:not-allowed;
    opacity: 0.4;
    }

  }
  `,

  black: `
  color: #fff;
  border-radius: 8px;
  background: #131315;
  overflow: hidden;
  padding:0 8px;

  &:hover {
    opacity: 0.9;
  }

  &:active {
    opacity: 0.9;
  }

   &:disabled {
    cursor:not-allowed;
    opacity: 0.4;
    }

}
`,

  gray: `
    color: #edeff5;
    border-radius: 8px;
    background: #3D3C41;
    overflow: visible;

    &:hover {
      opacity: 0.9;
    }

    &:active {
      opacity: 0.9;
    }

    &:disabled {
    cursor:not-allowed;
    opacity: 0.4;
    }

  }
  `,

  secondary: `
    color: #edeff5;
    border-radius: 8px;
    background: #27262B;
    overflow: hidden;

    &:hover {
      opacity: 0.9;
    }

    &:active {
      opacity: 0.9;
      background: #3d383f;
    }

      &:disabled {
    cursor:not-allowed;
    opacity: 0.4;
    }
  `,

  pink: `
    background: linear-gradient(225deg, #BF5AF2 0%, #0B84FF 100%), 
               linear-gradient(0deg, #0A84FF 0%, #0A84FF 100%), 
               #30D158;
  `,

  'blue-auth': `
    background-color: #2672FF;
  `,

  yellow: `
    background: linear-gradient(246deg, #FF9F0A 0%, #FFD60A 68.98%),
               linear-gradient(90deg, #FF375F 0%, #BA1B3B 100%),
               linear-gradient(0deg, #FF375F 0%, #FF375F 100%),
               linear-gradient(246deg, #B81500 0%, #D95E00 68.98%),
               #2247C6;
    color: #000000;
  `,

  blue: `
    border-radius: 8px;
    background: linear-gradient(126deg, #5BDBFF 1.05%, rgba(91, 219, 255, 0.00) 46.67%), #2672FF;

    &:hover {
      background-image: url(/images/background/spin-button.svg);
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
    }
  `,

  green: `
    border-radius: 8px;
    background: linear-gradient(103deg, #60FF65 -8.65%, rgba(96, 255, 101, 0.00) 26.92%), #2AA30A;
    box-shadow: 0px 0px 8px 0px #5CFF69 inset;
  `,

  orange: `
    background: linear-gradient(90deg, rgba(204, 127, 8, 0.00) 0%, #B65E00 100%), #FF9F0A;
  `,

  success: `
    background-color: green;
    color: white;
  `,

  danger: `
    background-color: rgba(208, 51, 49, 0.50);
    color: white;

       &:disabled {
    cursor:not-allowed;
    opacity: 0.4;
    }

    // &:disabled {
    //   border-radius: 8px;
    //   opacity: 0.4;
    //   background: rgba(208, 51, 49, 0.50);
    //   box-shadow: 0px 1px 1px 0px rgba(239, 241, 243, 0.20) inset;
    //   cursor: not-allowed;
    // }
  `,

  transparent: `
    background-color: transparent;
  `,

  wishlist: `
    background-color: rgba(65, 77, 107, 0.4);
  `,

  notify: `
    background-color: #153297;
  `,

  bonusBlue: `
    background: linear-gradient(90deg, #0B84FF 0%, #074F99 100%), #0B84FF;
  `,

  bonusYellow: `
    background: linear-gradient(90deg, rgba(204, 127, 8, 0.00) 0%, #B65E00 100%), #FF9F0A;
  `,
};
